import React, { useState, useRef, useEffect } from "react";
import Modal from "../../../Modals/Modal";
import { MODAL_CLOSE, STORIES } from "src/constants/images";

const DeleteStoryModal = ({
  onClose,
  isVisible,
  handleDeleteStory,
  deletingStoryID,
  gbetInWallet,
  ggInWallet,
  storyCostDeletion,
}) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="storyModal card "
    >
      <div className="deleteStoryModalContainer">
        <div className="header">
          <h5>Delete Story</h5>
          <div
            onClick={() => onClose()}
            onKeyPress={(e) => e.code == "Enter" && onClose()}
            className="close-modal"
          >
            <img src={MODAL_CLOSE.SOURCE} alt="close" />
          </div>
        </div>
        <div className="addStoryModal-body">
          <div className="info">
            <div className="left">
              {/* <div className="infoBody">
                Deleting story will make your NFT less prominent.
              </div> */}
              <div className="infoWallet">
                <span
                  style={{
                    color: "var( --add-story-text)",
                    fontWeight: 400,
                    fontSize: "16px",
                  }}
                >
                  You have <span>{gbetInWallet.toFixed(0)}</span> $GBET in your
                  wallet.
                </span>
              </div>
            </div>
            <div className="right">
              <div className="d-flex as-title">
                <div style={{ color: "var( --add-story-text)" }}>Fees</div>
                <span className="custom-tooltip">
                  <span className="tooltiptext">
                    $GBET used to delete a story will be permanently burnt.
                  </span>
                  <img
                    src={STORIES.INFO}
                    alt="info"
                    style={{ filter: "var(--svg-change-color)" }}
                  />
                </span>
              </div>
              <div className="d-flex as-fees">
                <div style={{ color: "var( --add-story-text)" }}>
                  <span>{storyCostDeletion}</span> $GBET
                </div>

                <img src={STORIES.CHEST} alt="info" />
                {/* <div>
                  {" & "} <span>25</span> $GG{" "}
                </div>
                <img src={STORIES.FIRE} alt="info" /> */}
              </div>
            </div>
          </div>
          {/* <div className="infoWallet">
            You have <span>112</span> $GBET and <span>243</span> $GG in your
            wallet.
          </div> */}
        </div>
        {/* <div className="body">
          {" "}
          Your story will be permanently deleted from the Blockchain.
        </div> */}
        <div className="body my-2 mb-4">
          Are you sure you want to delete this story?
        </div>
        <div className="buttons-ctas">
          <button
            className="red "
            onClick={() => {
              handleDeleteStory(deletingStoryID);
            }}
          >
            Delete
          </button>
          <button className="ghost mx-2" onClick={() => onClose()}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteStoryModal;
